import axios from 'axios';

const API_URL = 'https://api.serviceapplications.net/AppDocu/';

class AppDocuServiceCall {
  _getJwt() {
    return localStorage.getItem('jwt');
  }
  _getConfig(isFormData = false) {
    const jwt = this._getJwt();
    const headers = {
      'Accept': 'application/json',
      ...(isFormData
        ? {}
        : { 'Content-Type': 'application/json;charset=utf-8' }),
      ...(jwt ? { 'Authorization': 'Bearer ' + jwt } : {}),
    };
    return { headers };
  }

  async checkUser() {
    return axios.get(API_URL + 'check', this._getConfig());
  }

  // *** Documenti
  async listDocuments() {
    return axios.get(API_URL + 'document/list', this._getConfig());
  }
  async createDocument(data, config = {}) {
    // Merge onUploadProgress if provided
    const axiosConfig = { ...this._getConfig(true), ...config };
    return axios.post(API_URL + 'document/create', data, axiosConfig);
  }
  async updateDocument(data) {
    return axios.post(API_URL + 'document/update', data, this._getConfig());
  }
  async getDocument(id) {
    return axios.post(API_URL + 'document/get', { id }, this._getConfig());
  }
  async deleteDocument(id) {
    return axios.post(API_URL + 'document/delete', { id }, this._getConfig());
  }
  async getVehicleDocuments(machine_id) {
    return axios.get(API_URL + `machine/getDocuments?machine_id=${machine_id}`, this._getConfig());
  }
  async addVehicleDocument(machine_id, document_id) {
    return axios.post(API_URL + 'machine/addDocument', { machine_id, document_id }, this._getConfig());
  }
  async removeVehicleDocument(machine_id, document_id) {
    return axios.post(API_URL + 'machine/removeDocument', { machine_id, document_id }, this._getConfig());
  }

  // *** Calibrazioni
  async listCalibrations() {
    return axios.get(API_URL + 'calibration/list', this._getConfig());
  }
  async createCalibration(data, config = {}) {
    // Merge onUploadProgress if provided
    const axiosConfig = { ...this._getConfig(true), ...config };
    return axios.post(API_URL + 'calibration/create', data, axiosConfig);
  }
  async updateCalibration(data) {
    return axios.post(API_URL + 'calibration/update', data, this._getConfig());
  }
  async getCalibration(id) {
    return axios.post(API_URL + 'calibration/get', { id }, this._getConfig());
  }
  async deleteCalibration(id) {
    return axios.post(API_URL + 'calibration/delete', { id }, this._getConfig());
  }
  async getVehicleCalibrations(machine_id) {
    return axios.get(API_URL + `machine/getCalibrations?machine_id=${machine_id}`, this._getConfig());
  }
  async addVehicleCalibration(machine_id, calibration_id) {
    return axios.post(API_URL + 'machine/addCalibration', { machine_id, calibration_id }, this._getConfig());
  }
  async removeVehicleCalibration(machine_id, calibration_id) {
    return axios.post(API_URL + 'machine/removeCalibration', { machine_id, calibration_id }, this._getConfig());
  }
  
  /**
   * Get all vehicles associated with a calibration
   * 
   * Endpoint: GET /AppDocu/calibration/getMachines?calibration_id={id}
   * 
   * Response format:
   * {
   *   "is_valid": true,
   *   "machines": [
   *     {
   *       "machine_id": 1080,
   *       "brand": "Alfa Romeo",
   *       "model": "MODELLO PER TEST",
   *       "engine_code": "engine code",
   *       "power": 251,
   *       "cylinders": 9,
   *       "displacement": 3001,
   *       "document_count": 3,
   *       "package_count": 7,
   *       "calibration_count": 4
   *     }
   *   ],
   *   "associations": [
   *     {
   *       "machine_id": 1080,
   *       "calibration_id": 5,
   *       "package_id": 12
   *     },
   *     {
   *       "machine_id": 1080,
   *       "calibration_id": 5,
   *       "package_id": null
   *     }
   *   ],
   *   "message": "ok"
   * }
   * 
   * The associations array contains all rows from app_Machine_Packages_Calibrations
   * where calibration_id matches. Each row has machine_id, calibration_id, and package_id.
   * If package_id is not null, it means this calibration is associated together with a package.
   */
  async getCalibrationVehicles(calibration_id) {
    return axios.get(API_URL + `calibration/getMachines?calibration_id=${calibration_id}`, this._getConfig());
  }
  async getDocumentVehicles(document_id) {
    return axios.get(API_URL + `document/getMachines?document_id=${document_id}`, this._getConfig());
  }

  /**
   * BACKEND IMPLEMENTATION NEEDED:
   * 
   * Endpoint: POST /AppDocu/calibration/addToMachines
   * Request body: { calibration_id: number, machine_ids: number[] }
   * 
   * Logic:
   * - For each machine_id in machine_ids array:
   *   - Check if row exists with (machine_id, calibration_id)
   *   - If NOT exists: INSERT new row with (machine_id, package_id=NULL, calibration_id)
   *   - If exists: do nothing (already associated)
   * 
   * Response: { is_valid: boolean, message?: string, added_count?: number }
   */
  async addCalibrationToMachines(calibration_id, machine_ids) {
    return axios.post(API_URL + 'calibration/addToMachines', 
      { calibration_id, machine_ids }, 
      this._getConfig()
    );
  }

  /**
   * BACKEND IMPLEMENTATION NEEDED:
   * 
   * Endpoint: POST /AppDocu/calibration/removeFromMachines
   * Request body: { calibration_id: number, machine_ids: number[] }
   * 
   * Logic:
   * - For each machine_id in machine_ids array:
   *   - Find rows with (machine_id, calibration_id)
   *   - If row has package_id IS NULL: DELETE the row
   *   - If row has package_id IS NOT NULL: UPDATE calibration_id = NULL (keep the packet)
   * 
   * This ensures that if a calibration is part of a packet+calibration association,
   * we remove only the calibration but preserve the packet association.
   * 
   * Response: { is_valid: boolean, message?: string, removed_count?: number, updated_count?: number }
   */
  async removeCalibrationFromMachines(calibration_id, machine_ids) {
    return axios.post(API_URL + 'calibration/removeFromMachines', 
      { calibration_id, machine_ids }, 
      this._getConfig()
    );
  }

  /**
   * BACKEND IMPLEMENTATION NEEDED:
   * 
   * Endpoint: POST /AppDocu/document/addToMachines
   * Request body: { document_id: number, machine_ids: number[] }
   * 
   * Logic:
   * - For each machine_id in machine_ids array:
   *   - Check if row exists with (machine_id, document_id)
   *   - If NOT exists: INSERT new row
   *   - If exists: do nothing (already associated)
   * 
   * Response: { is_valid: boolean, message?: string, added_count?: number }
   */
  async addDocumentToMachines(document_id, machine_ids) {
    return axios.post(API_URL + 'document/addToMachines', 
      { document_id, machine_ids }, 
      this._getConfig()
    );
  }

  /**
   * BACKEND IMPLEMENTATION NEEDED:
   * 
   * Endpoint: POST /AppDocu/document/removeFromMachines
   * Request body: { document_id: number, machine_ids: number[] }
   * 
   * Logic:
   * - For each machine_id in machine_ids array:
   *   - DELETE FROM machine_document_association WHERE machine_id=? AND document_id=?
   * 
   * Response: { is_valid: boolean, message?: string, removed_count?: number }
   */
  async removeDocumentFromMachines(document_id, machine_ids) {
    return axios.post(API_URL + 'document/removeFromMachines', 
      { document_id, machine_ids }, 
      this._getConfig()
    );
  }

  /**
   * BACKEND IMPLEMENTATION NEEDED:
   * 
   * Endpoint: POST /AppDocu/package/addToMachines
   * Request body: { package_id: number, machine_ids: number[] }
   * 
   * Logic:
   * - For each machine_id in machine_ids array:
   *   - Check if row exists with (machine_id, package_id)
   *   - If NOT exists: INSERT new row with (machine_id, package_id, calibration_id=NULL)
   *   - If exists: do nothing (already associated)
   * 
   * Response: { is_valid: boolean, message?: string, added_count?: number }
   */
  async addPacketToMachines(package_id, machine_ids) {
    return axios.post(API_URL + 'package/addToMachines', 
      { package_id, machine_ids }, 
      this._getConfig()
    );
  }

  /**
   * BACKEND IMPLEMENTATION NEEDED:
   * 
   * Endpoint: POST /AppDocu/package/removeFromMachines
   * Request body: { package_id: number, machine_ids: number[] }
   * 
   * Logic:
   * - For each machine_id in machine_ids array:
   *   - Find rows with (machine_id, package_id)
   *   - If row has calibration_id IS NULL: DELETE the row
   *   - If row has calibration_id IS NOT NULL: UPDATE package_id = NULL (keep the calibration)
   * 
   * This ensures that if a packet is part of a packet+calibration association,
   * we remove only the packet but preserve the calibration association.
   * 
   * Response: { is_valid: boolean, message?: string, removed_count?: number, updated_count?: number }
   */
  async removePacketFromMachines(package_id, machine_ids) {
    return axios.post(API_URL + 'package/removeFromMachines', 
      { package_id, machine_ids }, 
      this._getConfig()
    );
  }

  // *** Feasibility
  async feasibilityList(params = {}) {
    // elenca tutti i brand disponibili oppure i modelli di un certo brand
    // params: opzionale, può contenere brand
    let url = API_URL + 'feasibility/list';
    const query = [];
    if (params.brand) query.push('brand=' + encodeURIComponent(params.brand));
    if (query.length > 0) url += '?' + query.join('&');
    return axios.get(url, this._getConfig());
  }
  async feasibilitySearch(brand, model, engine_code, com_brand) {
    // POST /AppDocu/machine/search
    return axios.post(API_URL + 'feasibility/search', { brand, model, engine_code, com_brand }, this._getConfig());
  }
  async feasibilityListQuestion() {
    // GET /AppDocu/feasibility/listQuestion
    // Recent questions list for feasibility chat
    return axios.get(API_URL + 'feasibility/listQuestion', this._getConfig());
  }
  /**
   * Conversational AI endpoint to progressively identify vehicle + intent
   * @param {string} message - user message
   * @param {object} state - previous state object returned by server (brand, model, engine_code, petrol_ecu, intent, language, question)
   * @param {string} selection_type - type of selection made by user among proposed options (brand|model|engine_code|petrol_ecu|intent|question)
   */
  async feasibilityChatAi(message, follow_up, state, selection_type, com_brand) {
    // POST /AppDocu/feasibility/chatAi (simplified stateless API)
    // follow_up is required for session tracking after the first response
    // when continuing a flow you MUST send back the state received previously.
    // selection_type is required for user selections among proposed options (brand|model|engine_code|petrol_ecu|intent|question)
    // com_brand is the company brand context
    const payload = { message, follow_up };
    if (state) payload.state = state;
    if (selection_type) payload.selection_type = selection_type;
    if (com_brand) payload.com_brand = com_brand;
    return axios.post(API_URL + 'feasibility/chatAi', payload, this._getConfig());
  }
  async feasibilityAskAi(question, hash) {
    // POST /AppDocu/feasibility/askAi
    return axios.post(API_URL + 'feasibility/askAi', { question, hash }, this._getConfig());
  }
  
  // *** Vehicle
  async listVehicles(params = {}) {
    // params: opzionale, può contenere brand
    let url = API_URL + 'machine/list';
    const query = [];
    if (params.brand) query.push('brand=' + encodeURIComponent(params.brand));
    if (query.length > 0) url += '?' + query.join('&');
    return axios.get(url, this._getConfig());
  }
  async createVehicle(data) {
    return axios.post(API_URL + 'machine/create', data, this._getConfig());
  }
  async updateVehicle(data) {
    return axios.post(API_URL + 'machine/update', data, this._getConfig());
  }
  async deleteVehicle(id) {
    return axios.post(API_URL + 'machine/delete', { id }, this._getConfig());
  }
  async getVehicle(id) {
    return axios.post(API_URL + 'machine/get', { id }, this._getConfig());
  }
  
  // *** Packet
  async listPackets() {
    return axios.get(API_URL + 'package/list', this._getConfig());
  }
  async createPacket(data) {
    return axios.post(API_URL + 'package/create', data, this._getConfig());
  }
  async updatePacket(data) {
    return axios.post(API_URL + 'package/update', data, this._getConfig());
  }
  async deletePacket(id) {
    return axios.post(API_URL + 'package/delete', { id }, this._getConfig());
  }
  async getPacket(id) {
    return axios.post(API_URL + 'package/get', { id }, this._getConfig());
  }
  
  /**
   * Get all vehicles associated with a packet
   * 
   * Endpoint: GET /AppDocu/package/getMachines?package_id={id}
   * 
   * BACKEND MODIFICATION NEEDED - Add associations array like calibration endpoint:
   * 
   * Response format:
   * {
   *   "is_valid": true,
   *   "machines": [
   *     {
   *       "machine_id": 1080,
   *       "brand": "Alfa Romeo",
   *       "model": "MODELLO PER TEST",
   *       "engine_code": "engine code",
   *       "power": 251,
   *       "cylinders": 9,
   *       "displacement": 3001,
   *       "document_count": 3,
   *       "package_count": 7,
   *       "calibration_count": 4
   *     }
   *   ],
   *   "associations": [
   *     {
   *       "machine_id": 1080,
   *       "package_id": 12,
   *       "calibration_id": 5
   *     },
   *     {
   *       "machine_id": 1080,
   *       "package_id": 12,
   *       "calibration_id": null
   *     }
   *   ],
   *   "message": "ok"
   * }
   * 
   * SQL Logic (same as calibration):
   * SELECT machine_id, package_id, calibration_id 
   * FROM app_Machine_Packages_Calibrations 
   * WHERE package_id = :package_id
   * 
   * The associations array contains all rows where package_id matches.
   * If calibration_id is not null, it means this packet is associated together with a calibration.
   */
  async getPacketVehicles(package_id) {
    return axios.get(API_URL + `package/getMachines?package_id=${package_id}`, this._getConfig());
  }
  async getPacketCodes() {
    return axios.get(API_URL + `package/getCodes`, this._getConfig());
  }

  // *** Service Activity
  async listServiceActivities(skip, take, filters) {
    return axios.post(API_URL + `service_activity/list2?skip=${skip}&take=${take}`, {
      filters: filters 
    }, this._getConfig());
  }
  async countServiceActivities(filters) {
    return axios.post(API_URL + 'service_activity/count2', {
      filters: filters 
    }, this._getConfig());
  }
  async createServiceActivity(data) {
    return axios.post(API_URL + 'service_activity/create', data, this._getConfig());
  }
  async updateServiceActivity(data) {
    return axios.post(API_URL + 'service_activity/update', data, this._getConfig());
  }
  async deleteServiceActivity(id) {
    return axios.post(API_URL + 'service_activity/delete', { id }, this._getConfig());
  }
  async getServiceActivity(id) {
    return axios.post(API_URL + 'service_activity/get', { id }, this._getConfig());
  }
  async getActivityStats(params) {
    // params: { year: number, month?: number }
    const queryParams = new URLSearchParams();
    queryParams.append('year', params.year);
    if (params.month) queryParams.append('month', params.month);
    return axios.get(API_URL + `service_activity/_sdkjfhjksdhfkjds?${queryParams.toString()}`, this._getConfig());
  }
  
  /**
   * Download a protected file (document or calibration) with JWT
   * @param {string} endpoint - es: 'document/download' o 'calibration/download'
   * @param {string} file_hash
   * @param {string} file_name
   * @param {function} notifyFn - funzione di notifica per errori
   */
  async downloadProtectedFile(endpoint, file_hash, file_name, notifyFn) {
    if (!file_hash) return;
    const jwt = this._getJwt();
    if (!jwt) {
      if (notifyFn) notifyFn('Login required.', 'error');
      return;
    }
    const url = `${API_URL}${endpoint}?hash=${file_hash}`;
    try {
      const response = await fetch(url, {
        headers: { 'Authorization': `Bearer ${jwt}` }
      });
      if (!response.ok) throw new Error('Download error.');
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = file_name || 'download';
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      if (notifyFn) notifyFn('Download error.', 'error');
      console.error(error);
    }
  }

  // Vehicle-Packet-Calibration Association
  async getVehiclePacketsCalibrations(machine_id) {
    return axios.get(API_URL + `machine/getPackagesCalibrations?machine_id=${machine_id}`, this._getConfig());
  }
  async addVehiclePacketCalibration(machine_id, package_id, calibration_id) {
    return axios.post(API_URL + 'machine/addPackageCalibration', { machine_id, package_id, calibration_id }, this._getConfig());
  }
  async removeVehiclePacketCalibration(machine_id, package_id, calibration_id) {
    return axios.post(API_URL + 'machine/removePackageCalibration', { machine_id, package_id, calibration_id }, this._getConfig());
  }
  
}

export default new AppDocuServiceCall();
